const initialState = {
    data: [],
};
  
const authUser = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_LOGIN_SER':
      return { ...state, data: action.payload };
    default:
      return state;
  }
};

export default authUser;